import React, { useImperativeHandle, useRef } from "react";

import { BottomMenuPanel } from "../bottom-menu-panel";
import { BottomMenuButtons, IBottomMenuButtonsRef } from "../bottom-menu/buttons";
import { DesignsThumb } from "./designs-thumb";

import "./designs-panel.css";

export interface IDesignsPanelItem {
	productCode: string;
	predefinedProductName: string;
	thumbUrl: string;
	absoluteDesignUrl: string;
}
export interface IDesignsPanelRef {
	scrollIntoView(name: string | undefined, animate?: boolean): void;
}

interface IDesignsPanelProps {
	designs: readonly IDesignsPanelItem[];
	selectedPredefinedProductName?: string;
	onClick?(predefinedProductName: string): void;
}

export const DesignsPanel = ({
	designs,
	selectedPredefinedProductName,
	onClick,
	ref,
}: IDesignsPanelProps & { ref?: React.Ref<IDesignsPanelRef> }) => {
	const bottomMenuBarRef = useRef<IBottomMenuButtonsRef>(null);

	useImperativeHandle(
		ref,
		() => ({
			scrollIntoView: (name, animate = true) => {
				if (!bottomMenuBarRef.current) return;
				const index = designs.findIndex((d) => d.predefinedProductName === name);
				bottomMenuBarRef.current.scrollIntoView(index, {
					animate,
				});
			},
		}),
		[designs],
	);

	return (
		<BottomMenuPanel className="designs-panel">
			<BottomMenuButtons scrollableClassName="designs-panel__items" ref={bottomMenuBarRef}>
				{designs.map((design) => (
					<DesignsThumb
						key={design.predefinedProductName}
						thumbUrl={design.thumbUrl}
						isActive={selectedPredefinedProductName === design.predefinedProductName}
						onClick={() => {
							if (onClick) {
								onClick(design.predefinedProductName);
							}
						}}
					/>
				))}
			</BottomMenuButtons>
		</BottomMenuPanel>
	);
};
DesignsPanel.displayName = "DesignsPanel";
